// ─────────────────────────────────────────────────────────────
// src/config.js  —  SAFE TO COMMIT (publishable keys only)
//
// To go live:
//  1. Log into stripe.com → Developers → API keys
//     Replace STRIPE_PUBLISHABLE_KEY with your pk_live_... key
//
//  2. Log into stripe.com → Payment Links → + New
//     Set to "Customer chooses price" or fixed amounts
//     Copy the buy.stripe.com/... URL
//     Replace STRIPE_PAYMENT_LINK below
//
// The secret key (sk_live_...) must NEVER appear in this repo.
// ─────────────────────────────────────────────────────────────

export const STRIPE_PUBLISHABLE_KEY = "pk_live_REPLACE_ME"; // not used (Payment Links don't need it)
export const STRIPE_PAYMENT_LINK    = "https://buy.stripe.com/7sY6oI7O0foS9Rr5oAgQE00";

export const DONATION_AMOUNTS = [
  { label: "£5",  sublabel: "Covers 1 child for a month",  pence: 500  },
  { label: "£10", sublabel: "Helps a whole family",         pence: 1000 },
  { label: "£25", sublabel: "Sponsors new word sets",       pence: 2500 },
  { label: "£50", sublabel: "Keeps the lights on",          pence: 5000 },
];

// ── Design tokens ──────────────────────────────────────────────
// ADHD-friendly palette with teal-tinted neutrals (Impeccable: never use pure gray)
export const COLORS = {
  bg:           "#FAFCFB",       // very faint teal tint (not yellow-cream)
  bgCard:       "#FFFFFF",
  bgAlt:        "#F0F5F4",       // teal-tinted light gray
  primary:      "#0F766E",       // richer teal (more modern than steel-blue)
  primaryLight: "#E0F2F1",
  accent:       "#E8590C",       // warm orange (more punch than muted amber)
  success:      "#16A34A",
  successLight: "#DCFCE7",
  textPrimary:  "#0F1B24",       // near-black with teal tint
  textSecondary:"#3D5A5C",       // mid-tone teal-gray for subheadings
  textMuted:    "#6B8080",       // teal-tinted gray (not pure gray)
  tamilGold:    "#B45309",       // deeper amber for Tamil script
  border:       "#D4DEDE",       // teal-tinted border
  shadow:       "rgba(15,118,110,0.06)", // teal-tinted shadow
};

export const CAT_COLORS = {
  Verb:       { bg: "#FFF7ED", border: "#C2410C", text: "#9A3412" },
  Pronoun:    { bg: "#F0FDF4", border: "#16A34A", text: "#166534" },
  Noun:       { bg: "#EFF6FF", border: "#2563EB", text: "#1E40AF" },
  Adjective:  { bg: "#FAF5FF", border: "#7C3AED", text: "#5B21B6" },
  Question:   { bg: "#FFFBEB", border: "#D97706", text: "#92400E" },
  Expression: { bg: "#FFF1F2", border: "#E11D48", text: "#9F1239" },
  Family:     { bg: "#F0FDFA", border: "#0D9488", text: "#115E59" },
};
